import * as React from "react";
import { ReactSVG } from "react-svg";

import closeImg from "../../../images/x.svg";
import S from "./styles";

interface MessageProps {
  title: string;
  status?: "success" | "error";
  onClose: () => void;
}

const Message: React.FC<MessageProps> = ({
  title,
  status = "neutral",
  children,
  onClose,
}) => (
  <S.Message className={`message__status-${status}`}>
    <p className="message__title">{title}</p>
    {children ? <div className="message__content">{children}</div> : null}
    <ReactSVG
      src={closeImg.src}
      className="message__close-icon"
      onClick={onClose}
    />
  </S.Message>
);

export default Message;
